import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { injectIntl, FormattedMessage } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { updateUserSubscription } from '../../ducks/user.duck';

import {
  Page,
  LayoutSingleColumn,
  Footer,
  LayoutWrapperFooter,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  InlineTextButton,
  NamedLink
} from '../../components';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import StripePricingTable from './components/StripePricingTable';
import { isClientType, getUserSubscriptionLevel, isStartup } from '../../util/types';

import classNames from 'classnames';
import css from './SubscriptionPage.module.css';

export const SubscriptionPageComponent = props => {
  const { currentUser, scrollingDisabled, intl, onUpdateUserSubscription } = props;

  const hasSubscription = !!getUserSubscriptionLevel(currentUser);
  const userSubscriptionLevel = getUserSubscriptionLevel(currentUser);

  const title = intl.formatMessage({ id: 'SubscriptionPage.title' });

  const email = currentUser?.attributes?.email;
  const isClient = isClientType(currentUser);
  const isStartupProvider = isStartup(currentUser);

  const contractLink = isClient ? (
    <a href="https://semoto-bucket.s3.eu-west-2.amazonaws.com/1741009284726.pdf" target="_blank">Contract's</a>
  ) : (
    <a href="https://semoto-bucket.s3.eu-west-2.amazonaws.com/1741009272747.pdf" target="_blank">Contract's</a>
  )

  return (
    <Page title={title} scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer
            currentPage="SubscriptionsPage"
            desktopClassName={css.desktopTopbar}
            mobileClassName={css.mobileTopbar}
          />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>

          <div className={css.root}>
            <div className={css.container}>
              <h1 className={css.title}>
                <FormattedMessage id="SubscriptionPage.title" />
              </h1>
              <p className={css.subtitle}>
                <FormattedMessage
                  id="SubscriptionPage.subtitle"
                  values={{ contractLink }}
                />
              </p>

              {/* {!hasSubscription && (
                <>
                  <div className={css.freeSubscription}>
                    <h3 className={css.freeSubscriptionTitle}>Free subscription </h3>
                    <InlineTextButton className={css.freeSubscriptionBtn} onClick={() => onUpdateUserSubscription()}>
                      Get Started
                    </InlineTextButton>
                  </div>

                  <div className={css.subscriptionSeparator}>
                    <span>
                      or
                    </span>
                  </div>
                </>
              )} */}

              <div className={classNames(css.pricingTable, { [css.pricingTableWithSubscription]: hasSubscription }, { [css.pricingTableClient]: isClient })}>

                <div className={classNames(css.pricingTableItem, { [css.pricingTableItemSelected]: userSubscriptionLevel })}>
                  <h3 className={css.pricingItemTitle}>
                    Freemium
                    {/* {isClient ? "Tier 1" : "Freemium"} */}
                  </h3>
                  <span className={css.pricingItemSubTitle}></span>
                  <h4 className={classNames(css.pricingItemPrice, {[css.pricingItemPriceClient]: isClient})}>
                    FREE
                  </h4>
                  <InlineTextButton className={css.pricingItemButton} onClick={() => onUpdateUserSubscription()}>
                    Subscribe
                  </InlineTextButton>

                  <p className={css.pricingItemListLabel}>
                    This includes:
                  </p>
                  {isClient ? (
                    <ul className={css.pricingItemList}>
                      <li className={css.pricingItemListItem}>Providers Visibility - Limited</li>
                      <li className={css.pricingItemListItem}>Providers information - Limited</li>
                      <li className={css.pricingItemListItem}>Reviews visibility - Limited</li>
                      <li className={css.pricingItemListItem}>Offers - Limited</li>
                    </ul>
                  ) : isStartupProvider ? (
                    <ul className={css.pricingItemList}>
                      <li className={css.pricingItemListItem}>Public profile - Yes</li>
                      <li className={css.pricingItemListItem}>Transaction Fee - 15%</li>
                      <li className={css.pricingItemListItem}>Providers Visibility - Unlimited</li>
                    </ul>
                  ) : (
                    <ul className={css.pricingItemList}>
                      <li className={css.pricingItemListItem}>Join the ecosystem</li>
                      <li className={css.pricingItemListItem}>Referral from Semoto</li>
                      <li className={css.pricingItemListItem}><b>No Public Profile</b></li>
                      <li className={css.pricingItemListItem}>Transaction fee - 15%</li>
                      <li className={css.pricingItemListItem}>Providers Visibility - Limited</li>

                    </ul>
                  )}
                </div>

                <div className={css.pricingTableStripe}>
                  <StripePricingTable
                    userEmail={email}
                    isClient={isClient}
                    isStartup={isStartupProvider}
                  />
                </div>

                {isClient && (
                  <div className={css.pricingTableItem}>
                    <h3 className={css.pricingItemTitle}>
                      Procurement
                    </h3>
                    <span className={css.pricingItemSubTitle}>
                      {/* {isClient ? "Transaction - Free" : "Transaction - 10% + cap"} */}
                    </span>
                    <h4 className={classNames(css.pricingItemPrice, css.pricingItemPriceClient)}>
                      Contact us
                    </h4>
                    <NamedLink
                      className={css.pricingItemButton}
                      name="ContactPage"
                    >
                      Contact us
                    </NamedLink>

                    <p className={css.pricingItemListLabel}>
                      This includes:
                    </p>

                    <ul className={css.pricingItemList}>
                      <li className={css.pricingItemListItem}>Providers Visibility - Unlimited</li>
                      <li className={css.pricingItemListItem}>Providers information - Unlimited</li>
                      <li className={css.pricingItemListItem}>Reviews visibility - Unlimited</li>
                      <li className={css.pricingItemListItem}>Offers - Unlimited</li>
                      <li className={css.pricingItemListItem}>Consulting - Unlimited</li>
                      <li className={css.pricingItemListItem}>Acc manager</li>
                      <li className={css.pricingItemListItem}>Events</li>
                      <li className={css.pricingItemListItem}>Open RFP</li>
                      <li className={css.pricingItemListItem}>Delegated Selection</li>
                      <li className={css.pricingItemListItem}>Delegated Negotiation</li>
                    </ul>

                  </div>
                )}
                {!isClient && !isStartupProvider && (
                  <div className={css.pricingTableItem}>
                    <h3 className={css.pricingItemTitle}>
                      Enterprise Sponsors
                    </h3>
                    <span className={css.pricingItemSubTitle}>
                      {/* {isClient ? "Transaction - Free" : "Transaction - 10% + cap"} */}
                    </span>
                    <h4 className={css.pricingItemPrice}>
                      £300
                    </h4>
                    <NamedLink
                      className={css.pricingItemButton}
                      name="ContactPage"
                    >
                      Contact us
                    </NamedLink>

                  </div>
                )}
              </div>
            </div>
          </div>




          {/* <p className={css.pricingItemListLabel}>
                    This includes:
                  </p>
                  {isClient ? (
                    <ul className={css.pricingItemList}>
                      <li className={css.pricingItemListItem}>Concierge fee - free</li>
                      <li className={css.pricingItemListItem}>Escrow/Crypto payments</li>
                      <li className={css.pricingItemListItem}>Providers visibility</li>
                      <li className={css.pricingItemListItem}>Offers</li>
                      <li className={css.pricingItemListItem}>Reviews visibility</li>
                      <li className={css.pricingItemListItem}>VCs Demo day</li>
                      <li className={css.pricingItemListItem}>Badge</li>
                      <li className={css.pricingItemListItem}>Events pass</li>
                      <li className={css.pricingItemListItem}>Acc manager</li>
                    </ul>
                  ) : (
                    <ul className={css.pricingItemList}>
                      <li className={css.pricingItemListItem}>External Reviews - 3 verified</li>
                      <li className={css.pricingItemListItem}>Providers Visibility - Unlimited</li>
                      <li className={css.pricingItemListItem}>Data Analytics - Unlimited</li>
                      <li className={css.pricingItemListItem}>Escrow/Crypto payments</li>
                      <li className={css.pricingItemListItem}>Clients' rating</li>
                      <li className={css.pricingItemListItem}>Henanced Profile</li>
                      <li className={css.pricingItemListItem}>Clients Feedback</li>
                      <li className={css.pricingItemListItem}>Social media exposure</li>
                      <li className={css.pricingItemListItem}>Webinars/Events</li>
                      <li className={css.pricingItemListItem}>Offers listing</li>
                      <li className={css.pricingItemListItem}>Direct Referal</li>
                      <li className={css.pricingItemListItem}>Acc manager</li>
                      <li className={css.pricingItemListItem}>Top Positioning</li>
                      <li className={css.pricingItemListItem}>Badge</li>
                      <li className={css.pricingItemListItem}>Clients visibility</li>
                    </ul>
                  )} */}
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};


const mapStateToProps = state => {
  const { currentUser } = state.user;
  return {
    currentUser,
    scrollingDisabled: isScrollingDisabled(state),
  }
};

const mapDispatchToProps = dispatch => ({
  onUpdateUserSubscription: () => dispatch(updateUserSubscription()),
});

const SubscriptionPage = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl
)(SubscriptionPageComponent);

export default SubscriptionPage;
